import(/* webpackMode: "eager" */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(talents)/[lang]/talents/components/Footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/googleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/app/(talents)/[lang]/talents/index.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
